/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.submissions'},
});

const SubmissionsItem = () => (
  <RouteLinkItem
    route="midas/microcredentialing/submissions"
    title={messages.title}
  />
);

export default SubmissionsItem;
